import { render, staticRenderFns } from "./location-emails-sort-drop.vue?vue&type=template&id=93a13d82&scoped=true"
import script from "./location-emails-sort-drop.vue?vue&type=script&lang=js"
export * from "./location-emails-sort-drop.vue?vue&type=script&lang=js"
import style0 from "./location-emails-sort-drop.vue?vue&type=style&index=0&id=93a13d82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a13d82",
  null
  
)

export default component.exports